<template>
  <div>
    <van-overlay :show="show" z-index="5000">
      <div class="common-taost" @click.stop>
        <div class="title" v-if="options && options.title">{{
          options.title || ''
        }}</div>
        <div
          class="desc"
          v-html="options.message"
          v-if="options && options.message"
        ></div>
        <div class="btn-list">
          <div class="btn-item btn-cancel" @click="bindCancel"
            >{{
              (options && options.cancelButtonText) ||
              defaultOptions.cancelButtonText
            }}
          </div>
          <div class="btn-item btn-confirm" @click="bindConfirm"
            >{{
              (options && options.confirmButtonText) ||
              defaultOptions.confirmButtonText
            }}
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  data() {
    return {
      defaultOptions: {
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      },
      show: true
    }
  },
  watch: {
    value() {
      this.show = this.value
    }
  },
  created() {
    this.show = this.value
  },
  methods: {
    bindClose() {
      this.$emit('input')
    },
    bindConfirm() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.common-taost {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
  width: 248px;
  box-sizing: border-box;
  padding: 28px 20px 20px;
  background: linear-gradient(180deg, #ddfcff 0%, #effeff 35%, #ffffff 100%);
  border-radius: 12px;

  .title {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    margin-bottom: 17px;
    line-height: 22px;
  }

  .desc {
    margin-bottom: 30px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 24px;
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;

    .btn-item {
      width: 99px;
      height: 40px;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.08);
      border-radius: 20px;
    }

    .btn-confirm {
      background: #03d4e6;
      color: #ffffff;
    }
  }
}
</style>
